import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styles from "./styles.module.css";
function GainfulButton({ disabled, onClick, style, text, size, height, borderRadius, extraClassName, dataAttr, }) {
    return (_jsx("button", { type: "button", className: `noselect ${styles.gainfulbutton}
        ${disabled ? styles.disabled : ""}
        ${height === "high" ? styles.high : ""}
        ${size === "small" ? styles.buttonsmall : ""}
        ${size === "large" ? styles.buttonlarge : ""}
        ${size === "xlarge" ? styles.buttonxlarge : ""}
        ${size === "w40" ? styles.widthFourty : ""}
        ${size === "w60" ? styles.widthSixty : ""}
        ${size === "w100" ? styles.fullwidth : ""}
        ${extraClassName === "accountEditSubscriptionBtn" ? styles.accountEditSubscriptionBtn : ""}
        ${extraClassName === "accountRdBtn" ? styles.accountRdBtn : ""}
        ${extraClassName === "accountProductBtn" ? styles.accountProductBtn : ""}
        ${extraClassName === "accountBannerBtn" ? styles.accountBannerBtn : ""}
        ${extraClassName === "disabledBtn" ? styles.disabledBtn : ""}
        ${extraClassName === "upProductTopBanner" ? styles.upProductTopBanner : ""}
        ${extraClassName === "upProductGainfulTile" ? styles.upProductGainfulTile : ""}
        upProductReviews        
        ${extraClassName || ""}
        ${borderRadius === "borderRadius" && styles.borderRadius}`, onClick: onClick, style: { ...style }, "data-tracking": `${text} Button`, "data-profileclick": `${text} Button`, "data-attr": dataAttr || "gainful-button", children: text }));
}
export default GainfulButton;
